// Tipos e listas de dominio da Pre-Analise. SEM efeitos colaterais: este modulo
// e importado por shared/schema.ts e shared/routes.ts (bundle do client), entao
// nao pode puxar o catalogo gerado (templates.generated.ts).

export const PRE_ANALISE_TEMPLATE_VERSION = "forms-v1";

/** Serviços contratáveis. Os tipos anteriores permanecem somente para histórico. */
export const ACTIVE_SERVICE_TYPES = [
  "reclassificacao_monta",
  "nexo_causal",
  "sindicancia",
  "orcamento_tecnico",
] as const;
export type ActiveServiceType = (typeof ACTIVE_SERVICE_TYPES)[number];

export const SERVICE_TYPES = [
  "sindicancia_nexo",
  "auditoria_danos_valores",
  "pericia_bens_imoveis",
  "auditoria_oficinas",
  "reclassificacao_monta",
  "nexo_causal",
  "sindicancia",
  "orcamento_tecnico",
] as const;
export type ServiceType = (typeof SERVICE_TYPES)[number];
export type FormsServiceType = "sindicancia_nexo" | "auditoria_danos_valores" | "pericia_bens_imoveis" | "auditoria_oficinas";

export type ChecklistStage = "documental" | "pre_analise";

export const ORDER_STATUSES = [
  "rascunho",
  "solicitado",
  "aguardando_documentos",
  "em_pre_analise",
  "pendencia",
  "apto_para_execucao",
  "em_execucao",
  "em_revisao",
  "concluido",
  "cancelado",
] as const;
export type OrderStatus = (typeof ORDER_STATUSES)[number];

export type ChecklistItem = {
  id: string;
  order: number;
  section: string;
  category: string;
  label: string;
  required: boolean;
  sourceCode?: string;
  guidance?: string;
};

export type ChecklistTemplate = {
  serviceType: ServiceType;
  stage: ChecklistStage;
  version: string;
  items: readonly ChecklistItem[];
};
